<template>
  <div class="services">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="SunnyFit" name="SunnyFit"></el-tab-pane>
      <el-tab-pane label="Sports+" name="second"></el-tab-pane>
    </el-tabs>
    <div v-if="activeName === 'SunnyFit'">
      <h1>SunnyFit APP</h1>
      <h3>九月天电子科技智能手表方案手机客户端</h3>
      <div class="icon">
        <img src="../assets/images/AppServices/sunnyFit/icon.png">
      </div>
      <p>
        SunnyFit App 作为九月天电子科技的智能手表的手机连接终端起到了至关重要的作用，用户需要使用 SunnyFit去连接自己的智能手表，
        并使用SunnyFit 设置智能手表的很多功能。用户需要在 SunnyFit上设置自己的个人健康信息，以便智能手表能对用户的运动数据，
        做个性化且更加精准的数据分析与展示。在 SunnyFit中，有大量的智能手表上无法展示的健康运动分析数据，这些数据可以让用户更加了解自己的健康运动状况。
        当用户拿到我们的智能手表时，第一时间下载 SunnyFit App 成为了一件十分必要的事情。
      </p>
      <div class="show">
        <img src="../assets/images/AppServices/sunnyFit/主页面.jpg">
        <img src="../assets/images/AppServices/sunnyFit/设备界面.png">
        <img src="../assets/images/AppServices/sunnyFit/日.png">
      </div>
      <h4>丰富的数据体验</h4>
      <p>
        SunnyFit中展示了许多更加详细的运动与健康数据图标，从多个维度去阐释用户的运动与健康数据，使用户能够更加精准的对自己的健康与运动状况有更加客观的了解。
        如在 SunnyFit中不仅可以看到用户当日的计步数据和睡眠数据，还可以看到用户当日的计步数据分布情况，用户当日的有效活动量等数据。除了当日的计步数据，
        近期的计步数据趋势对比。
      </p>
      <h4>智能手表功能设置</h4>
      <div class="show">
        <img src="../assets/images/AppServices/sunnyFit/表盘选择.jpg">
      </div>
      <p>SunnyFit还可以通过蓝牙传输功能将手机上存储的照片或自带的表盘下载到手表终端设备并展示给客户，极大地满足客户对各种个性化表盘的需求。</p>
    </div>
    <div v-else>
      <h1>Sports+ APP</h1>
      <h3>九月天电子科技智能手表方案手机客户端</h3>
      <div class="icon">
        <img src="../assets/images/AppServices/sports/icon.png">
      </div>
      <p>
        Sports+ App 作为九月天电子科技的一款针对轻智能手表的手机连接终端起到了至关重要的作用，用户需要使用 Sports+去连接自己的智能手表，
        并使用Sports+同步智能手表的时间日期及各种数据。用户需要在 SunnyFit上设置自己的个人健康信息，以便智能手表能对用户的运动数据。
      </p>
      <h4>手表数据同步与个人信息管理</h4>
      <div class="show">
        <img src="../assets/images/AppServices/sports/1.png">
        <img src="../assets/images/AppServices/sports/2.png">
        <img src="../assets/images/AppServices/sports/3.png">
      </div>
      <h4>针对蓝牙智能行针手表的校时</h4>
      <div class="show">
        <img src="../assets/images/AppServices/sports/4.png">
        <img src="../assets/images/AppServices/sports/5.png">
        <img src="../assets/images/AppServices/sports/6.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppServices',
  data () {
    return {
      activeName: 'SunnyFit'
    }
  }
}
</script>

<style scoped lang="scss">
.services {
  text-align: left;
  margin: 20px auto;
  max-width: 1200px;
  @media screen and (max-width: 1250px) {
    & {
      margin: 20px 5%;
    }
  }
  h1 {
    font-size: 40px;
    font-weight: 500;
    margin: 30px 0;
    line-height: 1.25;
  }
  h3 {
    font-size: 28px;
    line-height: 1.8;
    margin-bottom: 24px;
    font-weight: 400;
    margin-top: 30px;
  }
  h4 {
    font-size: 24px;
    text-transform: uppercase;
    margin-bottom: 20px;
    color: #444444;
    font-weight: 400;
    margin-top: 30px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    margin: 20px 0;
  }
  .icon {
    text-align: center;
    margin: 80px auto;
    >img {
      width: 300px;
      height: 300px;
    }
  }
  .show {
    display: flex;
    flex-wrap: wrap;
    margin: 50px 0;
    >img {
      width: 30%;
      margin: auto;
    }
  }
}
</style>
